export default __webpack_public_path__ + "static/media/RDS.16ed38d7.svg";